import Auth from '@aws-amplify/auth';
import Analytics from '@aws-amplify/analytics';
import awsExport from '../../aws-export';

export default function init() {
  if (process.env.MY_ENV !== 'production') {
    return;
  }

  Auth.configure(awsExport);
  Analytics.configure(awsExport);
}
